export const background = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5526_35563)">
<path d="M19.7729 4.97266H4.22656V19.0285H19.7729V4.97266ZM14.5237 7.53756C15.4202 7.53756 16.1482 8.26412 16.1482 9.16136C16.1482 10.0586 15.4202 10.7852 14.5237 10.7852C13.6257 10.7852 12.8992 10.0586 12.8992 9.16136C12.8992 8.26412 13.6257 7.53756 14.5237 7.53756ZM18.741 17.0957C18.6319 17.3022 18.4173 17.4311 18.1843 17.4311H6.06861C5.83864 17.4311 5.6277 17.3066 5.51708 17.1059C5.4072 16.9053 5.41527 16.6606 5.53831 16.4658L9.07592 10.9067C9.30153 10.5507 9.69116 10.3325 10.1116 10.3252C10.5335 10.3164 10.9297 10.52 11.1692 10.8672L13.2449 13.8716L13.9905 12.6983C14.2168 12.3423 14.6057 12.1248 15.0261 12.1167C15.448 12.1087 15.8435 12.3115 16.0838 12.658L18.7007 16.4468C18.834 16.6387 18.8486 16.8877 18.741 17.0957Z" fill="url(#paint0_linear_5526_35563)"/>
<path d="M0 0.836914V1.9553V23.164H24V20.969V0.836914H0ZM21.7639 20.9273H2.23608V3.07374H21.7639V20.9273Z" fill="url(#paint1_linear_5526_35563)"/>
</g>
<defs>
<linearGradient id="paint0_linear_5526_35563" x1="4.22656" y1="12.0006" x2="19.7729" y2="12.0006" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF53FF"/>
<stop offset="1" stop-color="#99F1FF"/>
</linearGradient>
<linearGradient id="paint1_linear_5526_35563" x1="0" y1="12.0005" x2="24" y2="12.0005" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF53FF"/>
<stop offset="1" stop-color="#99F1FF"/>
</linearGradient>
<clipPath id="clip0_5526_35563">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`;
